import { render, staticRenderFns } from "./bluenHome.vue?vue&type=template&id=4f8bd8b8&scoped=true&"
import script from "./bluenHome.vue?vue&type=script&lang=js&"
export * from "./bluenHome.vue?vue&type=script&lang=js&"
import style0 from "./bluenHome.vue?vue&type=style&index=0&id=4f8bd8b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8bd8b8",
  null
  
)

export default component.exports